<script>
import { shouldPreserveRedirect } from '@/utils/redirect';

const Login = {
  methods: {
    async validateRedirect(result) {
      if (result) {
        const hasIndentPermission =
          result.current_user.permissions_list.includes('view_indent');
        const hasExceptionLandingPageFeature = result.features.includes(
          'exception_page_landing',
        );
        const hasExceptionViewPermission =
          result.current_user.permissions_list.includes('view_exception');
        const canLandExceptionPage = !!(hasExceptionViewPermission && hasExceptionLandingPageFeature);
        const hasInvoicePermission =
          result.current_user.permissions_list.includes('view_invoice');
        const hasRmPermission =
          result.current_user.permissions_list.includes('view_rate_matrix');
        const hasLiveDBPermission =
          result.current_user.permissions_list.includes('view_live_dashboard');
        const hasFAPFeaturePermission =
          result.current_user.permissions_list.includes(
            'view_freight_audit_process',
          ) &&
          result.features.includes('freight_audit_process') &&
          result.current_user.permissions_list.includes('view_depot');
        // const hasPayIndentsFeature = result.features.includes('pay_indents');
        const hasPayV2Feature = result.features.includes('payments_v2');
        const hasTrackDashboardPermission =
          result.current_user.permissions_list.includes('view_track_dashboard');
        const hasTripsPermission =
          result.current_user.permissions_list.includes('view_trips');
        const hasMapViewPermission =
          result.current_user.permissions_list.includes('view_map');
        const hasRejectionsPermission =
          result.current_user.permissions_list.includes('view_rejections');

        if (result.current_user.reset_password) {
          this.$router.push({ name: 'PasswordReset' });
          return;
        }
        if (
          result.configurations &&
          result.configurations.inlineManual &&
          result.configurations.inlineManual.api_key &&
          result.configurations.inlineManual.show
        ) {
          window.inlineManualTracking = {
            uid: result.current_user.id,
            email: result.current_user.email,
            name: result.current_user.name,
            roles: [result.current_user.role.type],
          };
          this.initializeInlineManual(
            result.configurations.inlineManual.api_key,
          );
          // lazy loading the inline manual initializaion
          const id = setInterval(() => {
            const check = this.createmanual();
            if (check) {
              clearInterval(id);
            }
          }, 5000);
        }
        const lastUrl = JSON.parse(localStorage.getItem('lastUrl'));
        const hasOrderHubPermission = result.current_user.permissions_list.includes('view_order_hub');
        const hasTrackFeature = result.features.includes('track_trace');
        const hideInbound = this.$hasPermission('hide_inbound_indents_selection') || false;
        const redirectUrl = this.$route.query.redirect_url;
        if (redirectUrl && shouldPreserveRedirect(redirectUrl)) {
          this.$router.push({ path: redirectUrl });
          return;
        }

        if (lastUrl && lastUrl.name === 'TrackDetails' && hasTrackFeature) {
          this.$router.push(lastUrl);
        } else if (hasOrderHubPermission) {
          this.$router.push({ name: 'OrderHub', params: { isFromLogin: true } });
        } else if (hasIndentPermission) {
          if (canLandExceptionPage) {
            this.$router.push({ name: 'Exception' });
          } else if (
            (window.location.hostname.includes('development24.pandostaging.in'))) {
            if (!hideInbound && (result.initial_landing_page_settings === 'INBOUND')) {
              this.$router.push({ name: 'InboundIndents' });
            } else {
              this.$router.push({ name: 'OutboundIndents' });
            }
          } else if (!hideInbound && (result.initial_landing_page_settings === 'INBOUND')) {
            this.$router.push({ name: 'InboundIndentsV2' });
          } else {
            this.$router.push({ name: 'OutboundIndentsV2' });
          }
        } else if (
          hasTrackFeature &&
          (hasTrackDashboardPermission ||
            hasTripsPermission ||
            hasMapViewPermission ||
            hasRejectionsPermission)
        ) {
          if (this.$hasPermission('view_trips')) {
            this.$router.push({ name: 'Trips' });
          } else if (this.$hasPermission('view_track_dashboard')) {
            this.$router.push({ name: 'TrackDashboard' });
          } else if (this.$hasPermission('view_map')) {
            this.$router.push({ name: 'Map View' });
          } else if (this.$hasPermission('view_rejections')) {
            this.$router.push({ name: 'Rejections' });
          }
        } else if (hasInvoicePermission) {
          // Hiding this page because no client use it, will add back if required
          // if (hasPayIndentsFeature) {
          //   this.$router.push({ name: 'Pay Indents' });
          // } else
          if (hasPayV2Feature) {
            this.$router.push({ name: 'Invoices' });
          } else {
            this.$router.push({ name: 'Invoice' });
          }
        } else if (hasRmPermission) {
          this.$router.push({ name: 'contract' });
        } else if (hasLiveDBPermission) {
          this.$router.push({ name: 'LiveDashboard' });
        } else if (hasFAPFeaturePermission) {
          this.$router.push({ name: 'Depot' });
        } else if (this.$hasPermission('view_dashboard')) {
          this.$router.push({ name: 'Dashboard' });
        } else if (this.$hasPermission('create_return_deliveries')) {
          this.$router.push({ name: 'Deliveries' });
        } else if (this.$hasPermission('approve_return_requests')) {
          this.$router.push({ name: 'ReturnRequest' });
        } else if (this.$hasPermission('view_payment_settlement')) {
          this.$router.push({ name: 'Pay-Settlement' });
        } else if (this.$hasFeature('riq_v2')) {
          this.$router.push({ name: 'RIQ' });
        } else if (this.$hasFeature('view_ratelookup')) {
          this.$router.push({ name: 'RateLookUp' });
        } else {
          this.$router.push({ name: 'MenuNavigator' });
        }
      }
      if (
        !result.current_user.has_accepted_terms_conditions &&
        result.configurations.terms_and_conditions &&
        result.configurations.terms_and_conditions.is_enabled
      ) {
        this.$store.commit('app/SHOW_TERMS_DIALOG', true);
      }
    },
    setFreshWidget(bootstrapResult) {
      if (this.$hasPermission('view_support_widget')) {
        const userMail =
          (
            bootstrapResult &&
            bootstrapResult.current_user &&
            bootstrapResult.current_user.email
          ).replace(/\+[^@]*/, '') || '';
        if (window.FreshWidget) {
          window.FreshWidget.init('', {
            queryString:
              '&widgetType=popup&submitTitle=Create+Ticket&' +
              `submitThanks=Your+ticket+has+been+Created!!&captcha=yes&helpdesk_ticket[requester]=${userMail}`,
            utf8: '✓',
            widgetType: 'popup',
            buttonType: 'text',
            buttonText: 'Support',
            buttonColor: '#006265',
            buttonBg: 'white',
            alignment: '4',
            offset: '0',
            submitThanks: 'Your ticket has been Created!!',
            formHeight: '500px',
            captcha: 'yes',
            url: 'https://support.pando.in',
            loadOnEvent: 'immediate',
          });
        }
      }
    },
    initializeInlineManual(apiKey) {
      try {
        const inlineWriterScriptElement = document.createElement('script');
        const t = document.getElementsByTagName('script')[0];
        inlineWriterScriptElement.setAttribute('async', 1);
        inlineWriterScriptElement.setAttribute('charset', 'UTF-8');
        t.parentNode.insertBefore(inlineWriterScriptElement, t);
        const baseUrl = this.environmentVariables.il_ml_base_url.replace(
          'API_KEY',
          apiKey,
        );
        inlineWriterScriptElement.setAttribute('src', baseUrl);
        document.head.appendChild(inlineWriterScriptElement);
      } catch (error) {
        console.log('Inline Manual Initialization Failed', error);
      }
    },
    createmanual() {
      try {
        // eslint-disable-next-line no-undef
        createInlineManualPlayer(window.inlineManualPlayerData);
        return true;
      } catch (error) {
        return false;
      }
    },
  },
};
export default Login;
</script>
